import { Tooltip, Button } from "@chakra-ui/react";

export interface TenantModel {
  Id: number;
  TenantID: string;
  Name: string;
  Description: string;
  PhoneNumber: string;
  Email: string;
  Address: string;
  IsActive: boolean;
  LicenseType: number;
  NoOfUsers: number;
  LicenseStartDate: Date;
  LicenseEndDate: Date;
  MaxLimitPerDay: number | null;
  MaxSize: number | null;
  TenantLicenseID: number;
  MaxTokenPerMonth: number | null;
}

// export interface TenantWithLicenses {
//     Id: number;
//     TenantID: string;
//     Name: string;
//     Description: string;
//     PhoneNumber: string;
//     Email: string;
//     Address: string;
//     IsActive: boolean;
//     Licenses: {
//       LicenseType: number;
//       NoOfUsers: number;
//       LicenseStartDate: string;
//       LicenseEndDate: string;
//       TenantLicenseID: number;
//       MaxTokenPerMonth: number;
//     }[];
//   }

export enum LicenseType {
  // Basic = 101,
  Pro = 102,
  Enterprise = 103,
}

// export interface TenantWithLicenses {
//   LicenseStartDate: string | number | Date;
//   LicenseEndDate: string | number | Date;
//   LicenseType(LicenseType: any): import("react").ReactNode;
//   Id: number;
//   BasicDetails: TenantBasicDetailModel;
//   Licenses?: {
//     LicenseType: number;
//     NoOfUsers: number;
//     LicenseStartDate: string;
//     LicenseEndDate: string;
//     TenantLicenseID: number;
//     MaxTokenPerMonth: number;
//   }[];
// }

export interface TenantWithLicenses {
  Id: number;
  BasicDetails: TenantBasicDetailModel;
  Licenses?: {
    LicenseType: number;
    NoOfUsers: number;
    LicenseStartDate: Date;
    LicenseEndDate: Date;
    TenantLicenseID: number;
    MaxTokenPerMonth: number;
    isLicenseActive: boolean;
    title: string;
  }[];
}

export interface TenantBasicDetailModel {
  Id: number;
  TenantID: string;
  Name: string;
  Description: string;
  PhoneNumber: string;
  Email: string;
  Address: string;
  IsActive: boolean;
  IsTrial: boolean;
  DailyProcessLimitPerUser: number;
  TeamAppId?: string;
}

export interface LicenseRow {
  LicenseType: number;
  NoOfUsers: number;
  LicenseStartDate: Date;
  LicenseEndDate: Date;
  MaxTokenPerMonth: number | null;
  TenantLicenseID: number;
}


export interface LicenseModel {
  LicenseType: number;
  NoOfUsers: number;
  LicenseStartDate: Date;
  LicenseEndDate: Date;
  TenantLicenseID: number;
  MaxTokenPerMonth: number|null;
  LMAndBotTokens: number|null;
  assignedLicenses: number;
  availableLicenses: number;
  isLicenseActive: boolean;
  title: string;
}

export interface TenantBasicModel {
  Id: number;
  TenantID: string;
  Name: string;
  Description: string;
  PhoneNumber: string;
  Email: string;
  Address: string;
  IsActive: boolean;
  IsTrial: boolean;
  DailyProcessLimitPerUser: number;
  TeamAppId:string;
  Licenses?: LicenseModel[];
}


export const renderLicenseIcon = (licenseType: LicenseType) => {
  switch (licenseType) {
    // case LicenseType.Basic:
    //   return (
    //     <Tooltip label="Basic License" placement="top">
    //       <Button size="sm" colorScheme="blue" mr={2}>
    //         <i className="bi bi-file-earmark-text"></i>
    //       </Button>
    //     </Tooltip>
    //   );
    case LicenseType.Pro:
      return (
        <Tooltip label="Pro License" placement="top">
          <Button size="sm" colorScheme="green" mr={2}>
            <i className="bi bi-star"></i>
          </Button>
        </Tooltip>
      );
    case LicenseType.Enterprise:
      return (
        <Tooltip label="Enterprise License" placement="top">
          <Button size="sm" colorScheme="purple">
            <i className="bi bi-building"></i>
          </Button>
        </Tooltip>
      );
    default:
      return <span>No License</span>;
  }
};


// 1) color lookup
export const getLicenseColor = (licenseType: LicenseType): string => {
  switch (licenseType) {
    // case LicenseType.Basic:      // e.g. 101
    //   return "blue";
    case LicenseType.Pro:        // e.g. 102
      return "green";
    case LicenseType.Enterprise: // e.g. 103
      return "purple";
    default:
      return "gray";
  }
};

// 2) human‐readable name
export const getLicenseName = (licenseType: LicenseType): string => {
  switch (licenseType) {
    // case LicenseType.Basic:
    //   return "Basic";
    case LicenseType.Pro:
      return "Pro";
    case LicenseType.Enterprise:
      return "Enterprise";
    default:
      return "Unknown";
  }
};